import { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import Alert from 'react-bootstrap/Alert';
import { Navigate } from 'react-router-dom';
import PasswordStrengthBar from 'react-password-strength-bar';
import logo from './logo-final.svg';
import { InputPass } from './InputPass';
import { LoadingScreen } from '../Layout/LoadingScreen';
import authContext from '../../context/auth/authContext.js'
import { useForm } from '../../presentation/hooks/useForm';
import { isPassValid } from '../../presentation/utils/isPassValid';
import { showSuccessMessage } from '../../presentation/utils/showSuccessMessage';
import { handleLogout } from '../../presentation/utils/handleLogout';
import { handleError } from '../../presentation/utils/handleError';
import { changePasswordUseCase } from '../../di/usecase_module';
import { ChangePasswordRequestDto } from '../../domain/usecases/session/ChangePasswordUseCase';

export const UpdatePassword = () => {
  const { isLoadingActive } = useSelector(state => state.uiState);
  const AuthContext = useContext(authContext);
  const [isOpenRequirements, setisOpenRequirements] = useState(true);
  const { cambiar_pin } = AuthContext;

  const [message, setMessage] = useState(null);
  const [formValues, handleInputChange] = useForm({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const { oldPassword, newPassword, confirmPassword } = formValues;


   if (!cambiar_pin) {
     return <Navigate to="/home" replace={true} />
   }

  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage('');
    if (isPassValid(oldPassword, newPassword, confirmPassword, setMessage)) {
      changePasswordUseCase()
        .execute(new ChangePasswordRequestDto(
          encodeURIComponent(oldPassword),
          encodeURIComponent(newPassword)
        ))
        .then((_) => {
          showSuccessMessage({
            message: "La contraseña ha sido cambiada exitosamente. Inicia sesión con tu nueva contraseña para continuar"
          }, () => {
            handleLogout();
          });

        }).catch((e) => {
          handleError(e);
        })
    }
  }

  return (
    <>
      {
        (isLoadingActive)
        &&
        <LoadingScreen />
      }
      <div className="login-container justify-content-center align-items-center d-flex flex-column body-gradient"
        style={{ top: '0px', bottom: '0px', left: '0px', right: '0px', position: 'fixed' }}>
        <div className='p-2 altLogout'>
          <button type="button"
            className="d-md-block btn btn-logout ml-md-4" onClick={handleLogout}>Cerrar Sesión</button>
        </div>
        <div className="miclase col-lg-4 col-md-6 col-sm-12 bg-white shadow p-3">
          <form>
            {message && <Alert variant="warning" onClose={() => setMessage(null)} dismissible>
              {message}
            </Alert>}
            <div className="row justify-content-center p-3">
              <img style={{ width: `12rem` }} src={logo} alt="logo Redsmart" />
            </div>
            <div className="login-pdv text-center justify-content-center">
              <h2>Actualizar contraseña</h2>
            </div>
            <div className="row justify-content-center py-1 wrap-input-password">
              <InputPass
                name={'oldPassword'}
                maxLength={80}
                placeholder={'Ingresa contraseña actual'}
                handleInputChange={handleInputChange}
              >
              </InputPass>
            </div>
            <div className="row justify-content-center py-1 wrap-input-password">
              <InputPass
                name={'newPassword'}
                maxLength={80}
                placeholder={'Ingresa nueva contraseña'}
                handleInputChange={handleInputChange}
              >
              </InputPass>
            </div>
            <div className="row justify-content-center py-1 wrap-input-password">
              <InputPass
                name={'confirmPassword'}
                maxLength={80}
                placeholder={'Confirmar nueva contraseña'}
                handleInputChange={handleInputChange}
              >
              </InputPass>
            </div>
            {(newPassword) &&
              <>
                <div className='px-3'>
                  <PasswordStrengthBar
                    minLength='8'
                    shortScoreWord='demasiado corta'
                    scoreWords={['débil', 'débil', 'buena', 'muy buena', 'fuerte']}
                    password={newPassword} />
                </div>
              </>
            }
            <div className="row justify-content-center py-3">
              <button type="submit" className="btn col-10" id="logIn" onClick={handleSubmit}>Actualizar contraseña</button>
            </div>
          </form>
        </div>
        {(isOpenRequirements) &&
          <div className='passRequerimientos'>
            <small>La nueva contraseña debe cumplir con los siguientes requerimientos:</small>
            <ul>
              <li><small>Al menos <strong>8 carácteres</strong></small></li>
              <li><small>Incluir al menos <strong>una minúscula</strong></small></li>
              <li><small>Incluir al menos <strong>una mayúscula</strong></small></li>
              <li><small>Incluir al menos <strong>un número</strong></small></li>
              <li><small>No llevar espacio en blanco</small></li>
            </ul>
            <button type='button' className="close-button" onClick={() => setisOpenRequirements(!isOpenRequirements)}>X</button>
          </div>
        }
      </div>
    </>
  )
}